<template>
  <!-- Confirmation Section -->
  <div class="container content-space-2 content-space-lg-3">
    <div class="w-md-80 w-lg-80 text-center mx-md-auto">
      <img class="img-fluid" src="@/assets/images/svg/21.svg" alt="" />
      <div class="mt-3 mb-4">
        <h1>Page Not Found</h1>
        <p>The page you're looking for either doesn't exist or an error occurred</p>
      </div>
      <a class="btn btn-white transition-3d-hover px-5 me-2" href="#" @click="router.back()"
        ><i class="fas fa-reply me-2" aria-hidden="true" />Back</a
      >
      <router-link
        class="btn btn-primary transition-3d-hover px-5"
        target="_blank"
        :to="{ name: 'public.help-center' }"
      >
        Help Center
      </router-link>
    </div>
  </div>
  <!-- End Confirmation Section -->
</template>
<script setup>
import router from '@/router'
import { onMounted } from 'vue'
import usePrerender from '@/composables/prerender'

const { setPrerenderStatusCode, setPageReady } = usePrerender()

onMounted(() => {
  setPrerenderStatusCode(404)
  setPageReady()
})
</script>
